import { render } from "./Error.vue?vue&type=template&id=593a499c"
const script = {}

import "./Error.vue?vue&type=style&index=0&id=593a499c&lang=css"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__